import React from 'react';
import {Col, Row} from 'react-bootstrap';

const ChartLayout = ({heading, children}) => {
  return (
    <div className="dashboard-graph">
      <Row>
        <Col>
          <h4 className="mt-4">{heading}</h4>
        </Col>
      </Row>
      <Row>
        <Col>{children}</Col>
      </Row>
    </div>
  );
};

export default ChartLayout;
